import { render, staticRenderFns } from "./Euclid2xl700Black.vue?vue&type=template&id=24f78214&scoped=true&"
var script = {}
import style0 from "./Euclid2xl700Black.vue?vue&type=style&index=0&id=24f78214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f78214",
  null
  
)

export default component.exports